"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KettenSerieList = void 0;
const KettenSerie_1 = require("./KettenSerie");
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
/**
 * The `KettenSerieList` manages a list of `KettenSerie`
 */
class KettenSerieList extends echain_shared_oo_1.List {
    static fromScratch() {
        return new KettenSerieList();
    }
    static fromJson(json) {
        const list = new KettenSerieList();
        list.fromJson(json);
        return list;
    }
    itemsHaveEqualValues(item1, item2) {
        return item1.is(item2);
    }
    itemsAreSameEntity(item1, item2) {
        return item1.hasEqualValues(item2);
    }
    fromJson(json) {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(KettenSerie_1.KettenSerie.fromJson(itemJson));
        }
        this.emitChange();
    }
    toJson() {
        const json = [];
        for (const item of this.items) {
            json.push(item.toJson());
        }
        return json;
    }
    findKettenSerie(kette) {
        return this.get(kette.serieRef.id, 'id');
    }
    clone() {
        return KettenSerieList.fromJson(this.toJson());
    }
}
exports.KettenSerieList = KettenSerieList;
//# sourceMappingURL=KettenSerieList.js.map